<div class="openapi-properties-editor">
  @if (properties.length > 0 || showTitleWhenEmpty) {
    <div class="editor-header">
      <h4>{{ title }}</h4>
      @if (showAddButton) {
        <p-button
          icon="pi pi-plus"
          i18n-label="@@openapi.addProperty"
          label="Add Property"
          severity="primary"
          size="small"
          (click)="addProperty()">
        </p-button>
      }
    </div>
  }

  @if (readonlyProperties.length > 0) {
    <div class="readonly-properties-section">
      <h5 class="section-title">
        <i class="pi pi-lock"></i>
        <ng-container i18n="@@openapi.parentProperties">Parent Properties (Read-only)</ng-container>
      </h5>
      <p-table [value]="readonlyProperties" styleClass="properties-table readonly-table">
        <ng-template pTemplate="header">
          <tr>
            <th i18n="@@openapi.col.name">Name</th>
            <th class="hide-mobile" i18n="@@openapi.col.value">Value</th>
            <th i18n="@@openapi.col.type">Type</th>
            @if (allowLlmFill) {
              <th class="fill-mode-header" i18n="@@openapi.col.fillMode">Fill Mode</th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-property>
          <tr>
            <td>{{ property.name }}</td>
            <td class="hide-mobile">{{ formatDefault(property.default) }}</td>
            <td>{{ property.type }}</td>
            @if (allowLlmFill) {
              <td>
                <p-chip
                  [label]="getFillModeLabel(property.fillMode)"
                  [icon]="getFillModeIcon(property.fillMode)"
                  styleClass="fill-mode-chip">
                </p-chip>
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  <div class="properties-section">
    @if (readonlyProperties.length > 0) {
      <h5 class="section-title">
        <i class="pi pi-pencil"></i>
        <ng-container i18n="@@openapi.currentProperties">Current Properties</ng-container>
      </h5>
    }

    @if (properties.length === 0 && showEmptyState) {
      <div class="empty-state">
        <i class="pi pi-info-circle"></i>
        <p i18n="@@openapi.empty">No properties defined. Click "Add Property" to create one.</p>
        @if (showAddButton) {
          <p-button
            icon="pi pi-plus"
            i18n-label="@@openapi.addProperty"
            label="Add Property"
            severity="primary"
            size="small"
            (click)="addProperty()">
          </p-button>
        }
      </div>
    }
    @if (properties.length > 0) {
      <p-table [value]="properties" styleClass="properties-table">
        <ng-template pTemplate="header">
          <tr>
            <th i18n="@@openapi.col.name">Name</th>
            <th class="hide-mobile" i18n="@@openapi.col.value">Value</th>
            <th i18n="@@openapi.col.type">Type</th>
            @if (allowLlmFill) {
              <th class="fill-mode-header" i18n="@@openapi.col.fillMode">Fill Mode</th>
            }
            <th style="width: 12rem; text-align: center" class="actions-header" i18n="@@campaignItems.col.actions">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-property let-i="rowIndex">
          <tr>
            <td class="property-name-cell" (click)="onPropertyNameClick(property)">{{ property.name }}</td>
            <td class="hide-mobile">{{ formatDefault(property.default) }}</td>
            <td>{{ property.type }}</td>
            @if (allowLlmFill) {
              <td>
                <p-chip
                  [label]="getFillModeLabel(property.fillMode)"
                  [icon]="getFillModeIcon(property.fillMode)"
                  styleClass="fill-mode-chip">
                </p-chip>
              </td>
            }
            <td>
              <div class="actions-desktop">
                @if (showOrderButtons) {
                  <p-button
                    icon="pi pi-arrow-up"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    [disabled]="i === 0"
                    (click)="movePropertyUp(i)"
                    i18n-pTooltip="@@openapi.moveUp"
                    pTooltip="Move up"
                    i18n-ariaLabel="@@openapi.moveUp"
                    ariaLabel="Move up">
                  </p-button>
                  <p-button
                    icon="pi pi-arrow-down"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    [disabled]="i === properties.length - 1"
                    (click)="movePropertyDown(i)"
                    i18n-pTooltip="@@openapi.moveDown"
                    pTooltip="Move down"
                    i18n-ariaLabel="@@openapi.moveDown"
                    ariaLabel="Move down">
                  </p-button>
                }
                <p-button
                  icon="pi pi-pencil"
                  [text]="true"
                  [rounded]="true"
                  size="small"
                  (click)="editProperty(i)"
                  i18n-pTooltip="@@common.edit"
                  pTooltip="Edit"
                  i18n-ariaLabel="@@common.edit"
                  ariaLabel="Edit">
                </p-button>
                @if (showDeleteButton) {
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    (click)="removeProperty(i)"
                    i18n-pTooltip="@@common.delete"
                    pTooltip="Delete"
                    i18n-ariaLabel="@@common.delete"
                    ariaLabel="Delete">
                  </p-button>
                }
              </div>
              <div class="actions-mobile">
                @if (getActionsCount(i) === 1) {
                  <p-button
                    icon="pi pi-pencil"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    (click)="editProperty(i)"
                    i18n-pTooltip="@@common.edit"
                    pTooltip="Edit"
                    i18n-ariaLabel="@@common.edit"
                    ariaLabel="Edit">
                  </p-button>
                } @else {
                  <p-button
                    icon="pi pi-ellipsis-v"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    (click)="togglePropertyMenu($event, i)">
                  </p-button>
                }
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-menu #propertyMenu [model]="propertyMenuItems" [popup]="true"></p-menu>
    }
  </div>
</div>

<!-- Property Edit Drawer.
     [modal]="false" — компонент часто рендерится ВНУТРИ уже модального
     родительского drawer'а (например, model-properties-drawer). Два
     модальных drawer'а с одинаковым z-index'ом маски визуально
     затемняют друг друга и блокируют клики. Родитель уже даёт backdrop,
     наш drawer — просто под-панель поверх него. Клик снаружи всё равно
     закроет её через dismissible-поведение p-drawer'а. -->
<p-drawer
  [(visible)]="showPropertyDrawer"
  position="right"
  styleClass="property-drawer"
  [style]="{ width: '600px' }"
  [modal]="false"
  appPreventOverlayCloseOnScroll>
  <ng-template pTemplate="header">
    <h3>{{ editingPropertyIndex === -1 ? addPropertyTitle : editPropertyTitle }}</h3>
  </ng-template>

  @if (editingProperty) {
    <div class="drawer-content">
      <div class="property-form">
        <div class="form-field">
          <label i18n="@@openapi.col.name">Name</label>
          <input
            pInputText
            [(ngModel)]="editingProperty.name"
            i18n-placeholder="@@openapi.name.placeholder"
            placeholder="Property name (e.g., Authorization)"
            class="w-full">
        </div>

        <div class="form-field">
          <label i18n="@@openapi.col.title">Title</label>
          <input
            pInputText
            [(ngModel)]="editingProperty.title"
            i18n-placeholder="@@openapi.title.placeholder"
            placeholder="Display title (optional)"
            class="w-full">
        </div>

        <div class="form-field">
          <label i18n="@@openapi.col.type">Type</label>
          <p-select
            [options]="propertyTypes"
            [(ngModel)]="editingProperty.type"
            (ngModelChange)="onPropertyTypeChange(editingProperty)"
            i18n-placeholder="@@openapi.type.placeholder"
            placeholder="Select type"
            styleClass="w-full">
          </p-select>
        </div>

        <div class="form-field switch-field">
          <label i18n="@@openapi.nullable">Nullable</label>
          <p-toggleSwitch
            [(ngModel)]="editingProperty.nullable"
            (ngModelChange)="onNullableChange(editingProperty)">
          </p-toggleSwitch>
        </div>

        <div class="form-field">
          <label i18n="@@webhookTool.description.label">Description</label>
          <input
            pInputText
            [(ngModel)]="editingProperty.description"
            i18n-placeholder="@@openapi.description.placeholder"
            placeholder="Property description (optional)"
            class="w-full">
        </div>

        @if (allowLlmFill) {
          <div class="form-field">
            <label i18n="@@openapi.col.fillMode">Fill Mode</label>
            <p-selectButton
              [(ngModel)]="editingProperty.fillMode"
              (ngModelChange)="onFillModeChange(editingProperty)"
              [options]="fillModeOptions"
              optionLabel="label"
              optionValue="value"
              styleClass="w-full">
              <ng-template let-option pTemplate>
                <i [class]="option.icon"></i>
                <span>{{ option.label }}</span>
              </ng-template>
            </p-selectButton>
          </div>

          @if (editingProperty.fillMode === 'llm') {
            <div class="llm-info">
              <i class="pi pi-sparkles"></i>
              <span i18n="@@openapi.llmInfo">This field will be dynamically filled by AI based on context</span>
            </div>
          }
        }

        @if (editingProperty.type === 'enum') {
          <div class="form-field">
            <label i18n="@@openapi.enumType">Enum Type</label>
            <p-select
              [options]="enumTypeOptions"
              [(ngModel)]="editingProperty.enumType"
              (ngModelChange)="onEnumTypeChange(editingProperty)"
              i18n-placeholder="@@openapi.enumType.placeholder"
              placeholder="Select enum type"
              styleClass="w-full">
            </p-select>
          </div>

          <div class="form-field">
            <label i18n="@@openapi.enumOptions">Enum Options</label>
            <div class="enum-editor">
              <div class="enum-values-list">
                @for (enumValue of editingProperty.enum; track $index) {
                  <div class="enum-value-item">
                    <input
                      pInputText
                      [(ngModel)]="enumValue.label"
                      i18n-placeholder="@@openapi.enum.label"
                      placeholder="Label"
                      class="enum-label">
                    @if (editingProperty.enumType === 'string') {
                      <input
                        pInputText
                        [(ngModel)]="enumValue.value"
                        i18n-placeholder="@@openapi.enum.value"
                        placeholder="Value"
                        class="enum-value">
                    } @else if (editingProperty.enumType === 'integer') {
                      <p-inputNumber
                        [(ngModel)]="enumValue.value"
                        [showButtons]="true"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="0"
                        i18n-placeholder="@@openapi.enum.value"
                        placeholder="Value"
                        styleClass="enum-value">
                      </p-inputNumber>
                    } @else if (editingProperty.enumType === 'number') {
                      <p-inputNumber
                        [(ngModel)]="enumValue.value"
                        [showButtons]="true"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="10"
                        i18n-placeholder="@@openapi.enum.value"
                        placeholder="Value"
                        styleClass="enum-value">
                      </p-inputNumber>
                    }
                    <p-button
                      icon="pi pi-trash"
                      severity="danger"
                      [text]="true"
                      [rounded]="true"
                      size="small"
                      (click)="removeEnumValue(editingProperty, $index)">
                    </p-button>
                  </div>
                }
              </div>
              <p-button
                icon="pi pi-plus"
                i18n-label="@@openapi.addOption"
                label="Add Option"
                severity="secondary"
                [text]="true"
                size="small"
                (click)="addEnumValue(editingProperty)">
              </p-button>
            </div>
          </div>
        }

        @if (editingProperty.type === 'array') {
          <div class="array-config-section">
            <div class="form-field">
              <label i18n="@@openapi.arrayItemType">Array Item Type</label>
              <p-select
                [options]="arrayItemTypes"
                [(ngModel)]="editingProperty.items!.type"
                (ngModelChange)="onArrayItemTypeChange(editingProperty)"
                i18n-placeholder="@@openapi.selectItemType"
                placeholder="Select item type"
                styleClass="w-full">
              </p-select>
            </div>

            <div class="form-field">
              <label i18n="@@openapi.minItems">Minimum Items</label>
              <p-inputNumber
                [(ngModel)]="editingProperty.minItems"
                [showButtons]="true"
                [min]="0"
                i18n-placeholder="@@common.optional"
                placeholder="Optional"
                styleClass="w-full">
              </p-inputNumber>
            </div>

            <div class="form-field">
              <label i18n="@@openapi.maxItems">Maximum Items</label>
              <p-inputNumber
                [(ngModel)]="editingProperty.maxItems"
                [showButtons]="true"
                [min]="0"
                i18n-placeholder="@@common.optional"
                placeholder="Optional"
                styleClass="w-full">
              </p-inputNumber>
            </div>

            @if (editingProperty.items?.type === 'enum') {
              <div class="form-field">
                <label i18n="@@openapi.enumType">Enum Type</label>
                <p-select
                  [options]="enumTypeOptions"
                  [(ngModel)]="editingProperty.items!.enumType"
                  (ngModelChange)="onArrayEnumTypeChange(editingProperty)"
                  i18n-placeholder="@@openapi.enumType.placeholder"
                  placeholder="Select enum type"
                  styleClass="w-full">
                </p-select>
              </div>

              <div class="form-field">
                <label i18n="@@openapi.enumValues">Enum Values</label>
                <div class="enum-editor">
                  <div class="enum-values-list">
                    @for (enumValue of editingProperty.items!.enum; track $index) {
                      <div class="enum-value-item">
                        <input
                          pInputText
                          [(ngModel)]="enumValue.label"
                          placeholder="Label"
                          class="enum-label">
                        @if (editingProperty.items!.enumType === 'string') {
                          <input
                            pInputText
                            [(ngModel)]="enumValue.value"
                            placeholder="Value"
                            class="enum-value">
                        } @else if (editingProperty.items!.enumType === 'integer') {
                          <p-inputNumber
                            [(ngModel)]="enumValue.value"
                            [showButtons]="true"
                            [minFractionDigits]="0"
                            [maxFractionDigits]="0"
                            placeholder="Value"
                            styleClass="enum-value">
                          </p-inputNumber>
                        } @else if (editingProperty.items!.enumType === 'number') {
                          <p-inputNumber
                            [(ngModel)]="enumValue.value"
                            [showButtons]="true"
                            [minFractionDigits]="0"
                            [maxFractionDigits]="10"
                            placeholder="Value"
                            styleClass="enum-value">
                          </p-inputNumber>
                        }
                        <p-button
                          icon="pi pi-trash"
                          severity="danger"
                          [text]="true"
                          [rounded]="true"
                          size="small"
                          (click)="removeArrayEnumValue(editingProperty, $index)">
                        </p-button>
                      </div>
                    }
                  </div>
                  <p-button
                    icon="pi pi-plus"
                    i18n-label="@@openapi.addOption"
                    label="Add Option"
                    severity="secondary"
                    [text]="true"
                    size="small"
                    (click)="addArrayEnumValue(editingProperty)">
                  </p-button>
                </div>
              </div>
            }

            @if (editingProperty.items?.type === 'object') {
              <div class="nested-properties-section">
                <label class="section-label" i18n="@@openapi.arrayItemProperties">Array Item Properties</label>
                <app-openapi-properties-editor
                  [properties]="editingProperty.items!.properties || []"
                  [readonlyProperties]="[]"
                  [allowLlmFill]="allowLlmFill"
                  [allowedTypes]="allowedTypes"
                  [title]="itemPropertiesLabel"
                  (propertiesChange)="onArrayItemPropertiesChange(editingProperty, $event)">
                </app-openapi-properties-editor>
              </div>
            }
          </div>
        }

        @if (editingProperty.fillMode !== 'llm' && editingProperty.type !== 'object') {
          <div class="form-field">
            <label i18n="@@openapi.defaultValue">Default Value</label>
            @switch (editingProperty.type) {
              @case ('string') {
                <input
                  pInputText
                  [(ngModel)]="editingProperty.default"
                  [disabled]="editingProperty.isDefaultNull ?? false"
                  [placeholder]="editingProperty.isDefaultNull ? valueIsNullLabel : defaultValuePlaceholder"
                  class="w-full">
              }
              @case ('integer') {
                <p-inputNumber
                  [(ngModel)]="editingProperty.default"
                  [showButtons]="true"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="0"
                  [min]="editingProperty.minimum ?? -999999999"
                  [max]="editingProperty.maximum ?? 999999999"
                  [disabled]="editingProperty.isDefaultNull ?? false"
                  [placeholder]="editingProperty.isDefaultNull ? valueIsNullLabel : defaultValuePlaceholder"
                  styleClass="w-full">
                </p-inputNumber>
              }
              @case ('number') {
                <p-inputNumber
                  [(ngModel)]="editingProperty.default"
                  [showButtons]="true"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="10"
                  [min]="editingProperty.minimum ?? -999999999"
                  [max]="editingProperty.maximum ?? 999999999"
                  [disabled]="editingProperty.isDefaultNull ?? false"
                  [placeholder]="editingProperty.isDefaultNull ? valueIsNullLabel : defaultValuePlaceholder"
                  styleClass="w-full">
                </p-inputNumber>
              }
              @case ('boolean') {
                <p-toggleSwitch
                  [(ngModel)]="editingProperty.default"
                  [disabled]="editingProperty.isDefaultNull ?? false">
                </p-toggleSwitch>
              }
              @case ('enum') {
                <p-select
                  [options]="editingProperty.enum || []"
                  [(ngModel)]="editingProperty.default"
                  optionLabel="label"
                  optionValue="value"
                  [disabled]="editingProperty.isDefaultNull ?? false"
                  [placeholder]="editingProperty.isDefaultNull ? valueIsNullLabel : selectDefaultValuePlaceholder"
                  styleClass="w-full">
                </p-select>
              }
              @case ('array') {
                @if (!editingProperty.isDefaultNull) {
                  <div class="array-default-editor">
                    <div class="array-default-items-list">
                      @for (item of getArrayDefaultItems(editingProperty); track $index) {
                        <div class="array-default-item">
                          @switch (editingProperty.items?.type) {
                            @case ('string') {
                              <input
                                pInputText
                                [(ngModel)]="getArrayDefaultItems(editingProperty)[$index]"
                                i18n-placeholder="@@openapi.enum.value"
                                placeholder="Value"
                                class="array-item-value">
                            }
                            @case ('integer') {
                              <p-inputNumber
                                [(ngModel)]="getArrayDefaultItems(editingProperty)[$index]"
                                [showButtons]="true"
                                [minFractionDigits]="0"
                                [maxFractionDigits]="0"
                                i18n-placeholder="@@openapi.enum.value"
                                placeholder="Value"
                                styleClass="array-item-value">
                              </p-inputNumber>
                            }
                            @case ('number') {
                              <p-inputNumber
                                [(ngModel)]="getArrayDefaultItems(editingProperty)[$index]"
                                [showButtons]="true"
                                [minFractionDigits]="0"
                                [maxFractionDigits]="10"
                                i18n-placeholder="@@openapi.enum.value"
                                placeholder="Value"
                                styleClass="array-item-value">
                              </p-inputNumber>
                            }
                            @case ('boolean') {
                              <p-toggleSwitch
                                [(ngModel)]="getArrayDefaultItems(editingProperty)[$index]">
                              </p-toggleSwitch>
                            }
                            @case ('enum') {
                              <p-select
                                [options]="editingProperty.items!.enum || []"
                                [(ngModel)]="getArrayDefaultItems(editingProperty)[$index]"
                                optionLabel="label"
                                optionValue="value"
                                i18n-placeholder="@@openapi.selectValue"
                                placeholder="Select value"
                                styleClass="array-item-value">
                              </p-select>
                            }
                            @case ('object') {
                              <div class="object-placeholder array-item-value">
                                {{ '{' }} ... {{ '}' }}
                              </div>
                            }
                          }
                          <p-button
                            icon="pi pi-trash"
                            severity="danger"
                            [text]="true"
                            [rounded]="true"
                            size="small"
                            (click)="removeArrayDefaultItem(editingProperty, $index)">
                          </p-button>
                        </div>
                      }
                    </div>
                    <p-button
                      icon="pi pi-plus"
                      i18n-label="@@propertyEditor.addItem"
                      label="Add Item"
                      severity="secondary"
                      [text]="true"
                      size="small"
                      (click)="addArrayDefaultItem(editingProperty)">
                    </p-button>
                  </div>
                } @else {
                  <div class="null-placeholder">{{ valueIsNullLabel }}</div>
                }
              }
            }
          </div>

          @if (editingProperty.nullable) {
            <div class="form-field switch-field">
              <label i18n="@@openapi.valueIsNullLabel">Value is null</label>
              <p-toggleSwitch
                [(ngModel)]="editingProperty.isDefaultNull"
                (ngModelChange)="onIsDefaultNullChange(editingProperty)">
              </p-toggleSwitch>
            </div>
          }
        }

        @if (editingProperty.type === 'integer' || editingProperty.type === 'number') {
          <div class="form-field">
            <label i18n="@@openapi.minimum">Minimum</label>
            <p-inputNumber
              [(ngModel)]="editingProperty.minimum"
              [showButtons]="true"
              i18n-placeholder="@@common.optional"
              placeholder="Optional"
              styleClass="w-full">
            </p-inputNumber>
          </div>

          <div class="form-field">
            <label i18n="@@openapi.maximum">Maximum</label>
            <p-inputNumber
              [(ngModel)]="editingProperty.maximum"
              [showButtons]="true"
              i18n-placeholder="@@common.optional"
              placeholder="Optional"
              styleClass="w-full">
            </p-inputNumber>
          </div>
        }

        @if (editingProperty.type === 'object') {
          <div class="nested-properties-section">
            <label class="section-label" i18n="@@openapi.objectProperties">Object Properties</label>
            <app-openapi-properties-editor
              [properties]="editingProperty.properties || []"
              [readonlyProperties]="[]"
              [allowLlmFill]="allowLlmFill"
              [allowedTypes]="allowedTypes"
              [title]="nestedPropertiesLabel"
              (propertiesChange)="onNestedPropertiesChange(editingProperty, $event)">
            </app-openapi-properties-editor>
          </div>
        }
      </div>
    </div>
  }

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        i18n-label="@@common.cancel"
        label="Cancel"
        severity="secondary"
        [text]="true"
        (click)="cancelPropertyEdit()">
      </p-button>
      <p-button
        i18n-label="@@common.save"
        label="Save"
        icon="pi pi-save"
        severity="primary"
        (click)="savePropertyEdit()">
      </p-button>
    </div>
  </ng-template>
</p-drawer>
